import {
	ApiUtils,
	_axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/xlschool/list", params, successCallback, failCallback, exceptionCallback);
	},avibSkNames: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/xlschool/listAvibSkNames", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/xueli/xlschool/save", params, successCallback, failCallback, exceptionCallback);
	},
	saveClone: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/xlschool/clone", params, successCallback, failCallback, exceptionCallback);
	}, 
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/xlschool/toUpdate", params, successCallback, failCallback, exceptionCallback);
	}, 
	updateSubs: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/xueli/xlschool/updtSubs", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/xueli/xlschool/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/xueli/xlschool/remove", params, successCallback, failCallback, exceptionCallback);
	},
	cascadeSub: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/xlschool/cascadeSub", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
